import Link from 'next/link';
import Head from 'layouts/Head/Head';
import Header from 'layouts/Header/Header';
import Main from 'layouts/Main/Main';
import Footer from 'layouts/Footer/Footer';
import styles from './NotFoundPage.module.scss';

const NotFoundPage = (): JSX.Element => {
  return (
    <>
      <Head
        title="Page Not Found | MILLIONS"
        description="The page you are looking for does not exist or has been removed."
        robots="noindex, nofollow"
        disableCanonical
      />
      <Header />
      <Main
        backgroundColor="background-main"
        withoutBottomPadding
        className={styles.main}
      >
        <section className={styles.hero}>
          <div className={styles.content}>
            <div className={styles.copy}>
              <p className={styles.code}>404</p>
              <h1 className={styles.title}>Oops...page not found.</h1>
              <p className={styles.description}>
                Sorry, we couldn&apos;t find this page. But don&apos;t worry,
                you can find plenty of other things on our homepage.
              </p>
            </div>

            <div className={styles.actions}>
              <Link href="/" passHref>
                <a className={styles.homeButton}>Home</a>
              </Link>
            </div>
          </div>
        </section>
      </Main>
      <Footer />
    </>
  );
};

export default NotFoundPage;
